<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7">

    <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7">
      <div class="d-sm-flex align-items-center">
        <h5>Aniversariantes do Mês</h5>
      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25 mt-10">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Nome
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Telefone
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Dia do Aniversário
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Idade
              </th>
            </tr>
          </thead>
          <tbody>

            <tr v-for="(value, key) in getClientsBirthdayMonth" :key="key">

              <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                    {{ value.name != '' && value.name != null  ? value.name : 'Sem nome' }}
                  </div>
                </div>
              </th>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <a :href="`https://wa.me/55${value.phone}`" target="_blank" class="text-decoration-none">
                  {{ value.phone }}
                </a>
              </td>

              <td class="shadow-none lh-1 fw-medium">
                {{ value.birthday }}
              </td>

              <td class="shadow-none lh-1 fw-medium">
                {{ value.age }}
              </td>

            </tr>
          
          </tbody>
        </table>
      </div>

      <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mt-20">
        <div class="fs-14 text-muted mb-10 mb-sm-0">
          Página {{ currentPage }} de {{ getClientsBirthdayMonthPagination.last_page || 1 }} —
          Total de {{ getClientsBirthdayMonthPagination.total || getClientsBirthdayMonth.length }} clientes
        </div>
        <nav aria-label="Paginação de aniversariantes do mês">
          <ul class="pagination mb-0">
            <li class="page-item" :class="{ disabled: currentPage <= 1 }">
              <button type="button" class="page-link" @click="goToPage(currentPage - 1)" :disabled="currentPage <= 1">
                Anterior
              </button>
            </li>
            <li class="page-item" :class="{ disabled: currentPage >= getClientsBirthdayMonthPagination.last_page }">
              <button type="button" class="page-link" @click="goToPage(currentPage + 1)" :disabled="currentPage >= getClientsBirthdayMonthPagination.last_page">
                Próxima
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>

  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default defineComponent({
  name: "ClientsBirthdayMonth",
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    ...mapGetters([
      'getClientsBirthdayMonth',
      'getClientsBirthdayMonthPagination'
    ])
  },
  mounted() {
    this.loadPage(1);
  },
  methods: {
    ...mapActions([
      "fetchClientsBirthdayMonth"
    ]),
    async loadPage(page) {
      if (!page || page < 1) {
        page = 1;
      }
      this.currentPage = page;
      await this.fetchClientsBirthdayMonth(page);
    },
    goToPage(page) {
      if (page < 1 || (this.getClientsBirthdayMonthPagination.last_page && page > this.getClientsBirthdayMonthPagination.last_page)) {
        return;
      }
      this.loadPage(page);
    },
    formatBirthdayDay(date) {
      // convert YYYY-MM-DD to DD/MM
      if (!date) return '';
      return moment(date, 'YYYY-MM-DD').format('DD/MM');
    }
  }
});
</script>
